import axios from "axios";
import { toast } from "react-toastify";

async function refreshToken() {
  const response = await axios.get(
    `${
      process.env.REACT_APP_API_URL
    }/api/Auth/GenerateNewToken/${localStorage.getItem("username")}`
  );

  return response.data.token;
}

export function getCookie(name) {
  let cookies = document.cookie.split("; ");
  for (let cookie of cookies) {
    let [key, value] = cookie.split("=");
    if (key === name) return value;
  }
  return null;
}

let onSessionExpired = () => {};

export function setSessionExpiredHandler(callback) {
  onSessionExpired = callback;
}

const axiosInstance = axios.create({
  withCredentials: true,
});

axiosInstance.interceptors.request.use((config) => {
  const token = getCookie("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.code === "ERR_NETWORK") {
      toast.error(
        "Device is Not Connected to Network, Please Check Network Connection",
        {
          position: "bottom-center",
        }
      );
      return;
    }
    const originalRequest = error.config;

    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      try {
        const token = await refreshToken();
        document.cookie = "token=" + token;
        originalRequest.headers.Authorization = `Bearer ${token}`;

        return axiosInstance(originalRequest);
      } catch (refreshError) {
        onSessionExpired();
        return Promise.reject(refreshError);
      }
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;
